import React from 'react';

import { PORCELAIN, WHITE } from '@constant/colors';

const DownloadBox = () => (
  <svg className="download-box" viewBox="0 0 116 165">
    <defs>
      <rect id="download-box-a" width="116" height="165" rx="4" />
    </defs>
    <mask id="download-box-b" fill={WHITE}>
      <use xlinkHref="#download-box-a" />
    </mask>
    <use fill={WHITE} fillRule="evenodd" xlinkHref="#download-box-a" />
    <g fill="none" fillRule="evenodd" mask="url(#download-box-b)">
      <path
        d="M80.213 25.787c11.716 11.716 11.716 30.71 0 42.426-11.716 11.716-30.71 11.716-42.426 0-11.716-11.716-11.716-30.71 0-42.426 11.716-11.716 30.71-11.716 42.426 0zm-2.495 2.495c10.337 10.338 10.337 27.098 0 37.436-10.338 10.337-27.098 10.337-37.436 0-10.337-10.338-10.337-27.098 0-37.436 10.338-10.337 27.098-10.337 37.436 0z"
        fill="#E6E8EB"
      />
      <g transform="translate(49.118 36.412)" fill="#E6E8EB">
        <rect x="8.824" width="2.824" height="17.647" rx="1.412" />
        <rect
          transform="rotate(45 14.004 15.416)"
          x="12.592"
          y="8.357"
          width="2.824"
          height="14.118"
          rx="1.412"
        />
        <rect
          transform="rotate(-45 6.24 15.416)"
          x="4.827"
          y="8.357"
          width="2.824"
          height="14.118"
          rx="1.412"
        />
      </g>
    </g>
    <path
      d="M.496 132.5h115.008M-3 115.5h120"
      stroke={PORCELAIN}
      strokeLinecap="square"
      fill="none"
      mask="url(#download-box-b)"
    />
    <rect
      fill={PORCELAIN}
      fillRule="evenodd"
      mask="url(#download-box-b)"
      x="8"
      y="122"
      width="50"
      height="4"
      rx="2"
    />
    <rect
      fill={PORCELAIN}
      fillRule="evenodd"
      mask="url(#download-box-b)"
      x="28"
      y="143"
      width="60"
      height="14"
      rx="7"
    />
    <path
      d="M32 89c0-1.105.903-2 2.007-2h47.986c1.11 0 2.007.888 2.007 2 0 1.105-.903 2-2.007 2H34.007C32.897 91 32 90.112 32 89z"
      fill={PORCELAIN}
      fillRule="evenodd"
      mask="url(#download-box-b)"
    />
    <rect
      fill={PORCELAIN}
      fillRule="evenodd"
      mask="url(#download-box-b)"
      x="40"
      y="94"
      width="36"
      height="3"
      rx="1.5"
    />
  </svg>
);

export default DownloadBox;
